import Modal, { ModalVariant } from 'src/components/organisms/Modal';

export interface ConfirmationModalProps {
  // Async confirm handlers are common (the Modal awaits the result), so
  // accept both shapes. Previously typed `() => void` which silently
  // swallowed Promise rejections from `async` callers (ITL-2809 MAJ-5).
  // `Promise<unknown>` (not `Promise<void>`) so existing callers that
  // return a thunk dispatch promise (`Promise<PayloadAction<...>>`)
  // remain assignable — the parent ignores the resolved value, it just
  // awaits the promise.
  confirmationAction: () => void | Promise<unknown>;
  showConfirmationModal: boolean;
  setShowConfirmationModal: (show: boolean) => void;
  modalTitle?: string;
  confirmButtonLabel?: string;
  modalText?: string;
  cancelButtonLabel?: string;
}

const ConfirmationModal = ({
  confirmationAction,
  showConfirmationModal,
  setShowConfirmationModal,
  modalTitle = 'Confirmation',
  confirmButtonLabel = 'Confirm',
  modalText = 'Are you sure you want to proceed?',
  cancelButtonLabel = 'Cancel'
}: ConfirmationModalProps) => {
  return (
    <Modal
      title={modalTitle}
      labelButtonConfirm={confirmButtonLabel}
      text={modalText}
      showModal={showConfirmationModal}
      onConfirm={async () => {
        setShowConfirmationModal(false);

        await confirmationAction();
      }}
      onCancel={() => setShowConfirmationModal(false)}
      variant={ModalVariant.none}
      labelButtonCancel={cancelButtonLabel}
    />
  );
};

export default ConfirmationModal;
